import { TURBO_CHART_INNER_PADDING } from '@chart';
import type { TerminalChartPane } from '@terminal/views/turbo-chart/utils/chart-utils/types';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './LegendPosition.module.scss';

export interface LegendPositionProps {
  children?: ReactNode | ReactNode[];
  className?: string;
  pane: TerminalChartPane;
  paneIndex: number;
}

const LEGEND_ITEM_HEIGHT = 36;

export const LegendPosition = ({
  children,
  className,
  pane,
  paneIndex,
}: LegendPositionProps) => {
  const chartAssetData = pane.chartAssetData;
  const legendItemHeights = LEGEND_ITEM_HEIGHT * chartAssetData.length;
  const height =
    legendItemHeights >= pane.options.height
      ? pane.options.height - TURBO_CHART_INNER_PADDING
      : undefined;

  const top =
    paneIndex === 0
      ? TURBO_CHART_INNER_PADDING
      : TURBO_CHART_INNER_PADDING + pane.options.gutters.top;

  return (
    <div
      data-testid="legend-position"
      className={clsx(styles.legendPositionRoot, className)}
      style={{ top, height }}
    >
      {children}
    </div>
  );
};
